import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk } from "../../lib/index";
import { FOLDERS } from "../doseeData/utils/Utils";
import { usePlugImageContext } from "../../context/PlugImageContext";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { FiImage, FiInfo } from "react-icons/fi";

const Add = () => {
  const { createOnePlugImage } = usePlugImageContext();
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [type, setType] = useState(null);
  const plugImageRoutes = "/plug/image";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setType(null);
  };

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const addOnePlugImageHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Plug Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = { type, photo_url: thumbnail, image_cdn_id: thumbnailId };
    const { status, message } = await createOnePlugImage(data);
    if (status === codeOk) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={plugImageRoutes}
      eyebrow="Catalog • Plug Images"
      title="Add Plug Image"
      subtitle="Upload a clear plug photo and label it with its type."
      icon={<FiImage className="h-5 w-5" />}
      loading={loading}
      submitLabel="Add Plug Image"
      onSubmit={addOnePlugImageHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Recommended 1200×675px, JPG or PNG, under 2MB."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.PLUGS}
        />
      </AddSection>

      <AddSection
        title="Plug Image Details"
        hint="Type names like Type C, Type G — keep them consistent."
        icon={<FiInfo className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InputField
            props={{
              id: "type",
              title: "Type",
              type: "text",
              value: type ? type : "",
              onChange: (e: any) => {
                setType(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
